// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"bf6c8176","202":"eaf4d802","223":"d1e5216e","671":"6da27e50","754":"d75d4dc0"}[chunkId] + ".css";
};